import { NetworkError, TooManyRequestsError, LockedError, BadRequestError } from '@sravni/utils/lib/errors/network';

const createNetworkError = (status, params) => {
    const { message, meta } = params || {};
    const { retryAfter } = meta || {};
    switch (status) {
        case 400:
            return new BadRequestError({ message });
        case 423:
            return new LockedError(message);
        case 429:
            return new TooManyRequestsError(message, retryAfter);
        default:
            return new NetworkError(message);
    }
};

export { createNetworkError };
//# sourceMappingURL=errorFabric.js.map
